import { extendBannerContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { forwardRef, useCallback } from "react";
import { useBanner, FooterLink, useCommonFooterLinks, useBannerStylesheet, LanguageSwitcher } from "../../..";

// eslint-disable-next-line react/display-name
const BannerFooter = /*#__PURE__*/forwardRef((_, ref) => {
  const {
    FooterContainer
  } = useBannerStylesheet().extend(...extendBannerContentStylesheet);
  const banner = useBanner();
  const {
    isTcf,
    layout: {
      type
    },
    footerDesign: {
      languageSwitcher: languageSwitcherChoice
    },
    individualPrivacyOpen,
    updateIndividualPrivacyOpen,
    onClose,
    i18n: {
      tcf
    },
    isConsentRecord,
    languageSwitcher
  } = banner;
  const handleTcfVendorList = process.env.IS_TCF === "1" && isTcf ? useCallback(e => {
    updateIndividualPrivacyOpen(true);
    e.preventDefault();
  }, [updateIndividualPrivacyOpen]) : undefined;
  const handleClose = useCallback(e => {
    onClose();
    e.preventDefault();
  }, [onClose]);
  const {
    rows: links,
    render: renderLinks
  } = useCommonFooterLinks({
    onClose: isConsentRecord ? handleClose : undefined,
    putPoweredByLinkInRow: type === "banner" ? 0 : 1,
    row1: [process.env.IS_TCF === "1" && isTcf && !individualPrivacyOpen && h(FooterLink, {
      href: "#",
      onClick: handleTcfVendorList,
      key: "vendorList"
    }, tcf.vendorList)],
    row1End: [(languageSwitcher === null || languageSwitcher === void 0 ? void 0 : languageSwitcher.length) > 0 && languageSwitcherChoice && languageSwitcherChoice !== "disabled" && h(LanguageSwitcher, {
      key: "languageSwitcher"
    })]
  });
  return h(FooterContainer, {
    ref: ref
  }, h("div", null, renderLinks(links)));
});
export { BannerFooter };